import { render, staticRenderFns } from "./UiCheck.vue?vue&type=template&id=6156784b"
import script from "./UiCheck.vue?vue&type=script&lang=js"
export * from "./UiCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports